import React from "react";

import { getStatusLabel } from "~/pages/purchase-orders/utils/statusLabels";

interface StatusBadgeProps {
  status: string;
  type?: "payment" | "order";
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, type }) => {
  if (!status) return null;

  let className = "";
  let label = "";

  if (type === "payment") {
    const paymentStatusColors = {
      pending: "bg-amber-100 text-amber-800",
      late: "bg-red-100 text-red-800",
      cleared: "bg-green-100 text-green-800",
    };

    const paymentStatusLabels = {
      pending: "Pendiente",
      late: "Atrasado",
      cleared: "Pagado",
    };

    className =
      paymentStatusColors[status as keyof typeof paymentStatusColors] || "";
    label =
      paymentStatusLabels[status as keyof typeof paymentStatusLabels] || status;
  } else {
    const orderStatusColors: Record<string, string> = {
      pending: "bg-amber-100 text-amber-800",
      pending_pricing: "bg-purple-100 text-purple-800",
      pending_credit: "bg-red-100 text-red-800",
      accepted: "bg-green-100 text-green-800",
      prepaid: "bg-orange-100 text-orange-800",
      payment_to_check: "bg-yellow-100 text-yellow-800",
      por_facturar: "bg-violet-100 text-violet-800",
      facturado: "bg-indigo-100 text-indigo-800",
      dispatch_ready: "bg-teal-100 text-teal-800",
      in_transit: "bg-blue-100 text-blue-800",
      delivered: "bg-blue-100 text-blue-800",
      rejected: "bg-red-100 text-red-800",
      cancelled: "bg-rose-100 text-rose-800",
      test: "bg-gray-100 text-gray-600",
    };

    className = orderStatusColors[status] || "bg-gray-100 text-gray-800";
    // Labels come from the single source of truth (statusLabels.ts). Unknown
    // slugs are humanized there, so a raw slug never reaches the UI.
    label = getStatusLabel(status);
  }

  return (
    <span className={`rounded-full px-2 py-1 text-xs font-medium ${className}`}>
      {label}
    </span>
  );
};

export default StatusBadge;
